import { Gift } from '@app/models/gift';
import { RAFBonuse } from '@app/models/raf-bonuses';
import { createAction, props } from '@ngrx/store';

export const setAll = createAction('[RAF Bonuses] Set All RAF Bonuses', props<{ rafBonuses: RAFBonuse[] }>());
